"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolApi = void 0;
var common_core_1 = require("@moralisweb3/common-core");
var ClientSolApi_1 = require("./generated/ClientSolApi");
var BASE_URL = 'https://solana-gateway.moralis.io';
var SolApi = /** @class */ (function (_super) {
    __extends(SolApi, _super);
    function SolApi(core) {
        return _super.call(this, SolApi.moduleName, core, BASE_URL) || this;
    }
    SolApi.create = function (core) {
        return new SolApi(core !== null && core !== void 0 ? core : common_core_1.CoreProvider.getDefault());
    };
    SolApi.prototype.setup = function () {
        // Nothing
    };
    SolApi.prototype.start = function () {
        // Nothing
    };
    SolApi.moduleName = 'solApi';
    return SolApi;
}(ClientSolApi_1.ClientSolApi));
exports.SolApi = SolApi;
//# sourceMappingURL=SolApi.js.map